module.exports = __webpack_public_path__ + "static/media/Logo-sm.8af64089.png";